import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import AppComponent from '../components/AppComponent';
import actions from '../redux/actions/login';

const mapStateToProps = (state) => ({
  user: state.user,
  coins: state.setting.coins,
});

const mapDispatchToProps = (dispatch) => ({
  logout(params) {
    dispatch(actions.logout(params));
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppComponent));
